/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function UserRemove({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#UserRemove_svg__a)"><path fillRule="evenodd" d="M2.65 4.5a3.6 3.6 0 1 1 7.2 0 3.6 3.6 0 0 1-7.2 0m3.6-2.4a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8M1.1 12.61C1.69 10.708 3.414 9.4 5.381 9.4h1.738c1.967 0 3.692 1.307 4.28 3.21l.128.41c.312 1.008-.415 2.08-1.5 2.08H2.473c-1.085 0-1.812-1.072-1.5-2.08zm4.281-2.01c-1.422 0-2.696.947-3.135 2.365l-.126.41c-.087.28.122.525.353.525h7.554c.231 0 .44-.245.353-.526l-.126-.41C9.814 11.548 8.54 10.6 7.119 10.6z" clipRule="evenodd" /><path d="M11 7.4a.6.6 0 1 0 0 1.2h4a.6.6 0 1 0 0-1.2z" /></g><defs><clipPath id="UserRemove_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;